import { useLocation } from 'react-router-dom';
import { useEffect, useRef, useState } from 'react';

/**
 * PageTransition
 * Wraps page content in a fade-in whenever the route pathname changes.
 * Pure CSS — no external animation libraries required.
 */
export default function PageTransition({ children }) {
  const location   = useLocation();
  const [show, setShow] = useState(true);
  const prevPath   = useRef(location.pathname);
  const timerRef   = useRef(null);

  useEffect(() => {
    if (location.pathname === prevPath.current) return;
    prevPath.current = location.pathname;

    // Fade out briefly, then fade back in
    setShow(false);
    clearTimeout(timerRef.current);
    timerRef.current = setTimeout(() => setShow(true), 60);

    return () => clearTimeout(timerRef.current);
  }, [location.pathname]);

  return (
    <div
      style={{
        opacity: show ? 1 : 0,
        transition: show ? 'opacity 0.28s ease' : 'opacity 0.06s ease',
        willChange: 'opacity',
      }}
    >
      {children}
    </div>
  );
}
